import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.is-finite.js";
import "core-js/modules/es.object.to-string.js";
import { questionnaireVersionTextLong } from '~/functions/esg';
import { useGetQuestionnairesForVenturesAndLabelQuery } from '~/types/types';
export default defineComponent({
  setup: function setup() {
    var route = useRoute();
    var ventureId = computed(function () {
      return route.params.venture;
    });
    var _useGetQuestionnaires = useGetQuestionnairesForVenturesAndLabelQuery({
        ventureIds: [ventureId.value],
        label: 'ESG'
      }),
      allQuestionnairesResult = _useGetQuestionnaires.result,
      loading = _useGetQuestionnaires.loading;
    var allEsgQuestionnaires = computed(function () {
      var _allQuestionnairesRes;
      var data = (_allQuestionnairesRes = allQuestionnairesResult.value) === null || _allQuestionnairesRes === void 0 ? void 0 : _allQuestionnairesRes.getQuestionnairesForVenturesAndLabel;
      if (!data) return [];
      return data.map(function (item, index) {
        return _objectSpread(_objectSpread({}, item), {}, {
          text: questionnaireVersionTextLong(item, data.length - index)
        });
      });
    });
    var latestQuestionnaireId = computed(function () {
      var all = allEsgQuestionnaires.value;
      if (all && all.length) return all[0].id;else return null;
    });

    // A reporting-request link passes ?questionnaireId=<id> so the company
    // lands on the specific period the request covered, not whichever
    // version happens to be most recent.
    var requestedQuestionnaireId = computed(function () {
      var raw = route.query.questionnaireId;
      var parsed = Number(Array.isArray(raw) ? raw[0] : raw);
      return Number.isFinite(parsed) ? parsed : null;
    });
    var initialQuestionnaireId = computed(function () {
      var requested = requestedQuestionnaireId.value;
      var isValid = requested !== null && allEsgQuestionnaires.value.some(function (q) {
        return q.id === requested;
      });
      return isValid ? requested : latestQuestionnaireId.value;
    });

    // const loading = useQueryLoading()

    return {
      allEsgQuestionnaires: allEsgQuestionnaires,
      latestQuestionnaireId: latestQuestionnaireId,
      initialQuestionnaireId: initialQuestionnaireId,
      loading: loading,
      ventureId: ventureId
    };
  },
  methods: {}
});